<template>
  <div class="mod-config">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item>
        <!-- <el-input
                    v-model="dataForm.departmentName"
                    placeholder="部门名称"
                    clearable
                ></el-input> -->
      </el-form-item>
      <el-form-item>
        <!-- <el-button @click="getDataList()">查询</el-button> -->
        <el-button @click="addOrUpdateHandle()">
          新增
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border style="width: 100%">
      <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
      <el-table-column
        prop="title"
        header-align="center"
        align="center"
        show-overflow-tooltip
        label="标题"
      >
        <template slot-scope="scope">
          <span>{{ showcontent(scope.row.title) }}</span>
        </template>
      </el-table-column>
      <table-tree-column
        prop="link"
        header-align="center"
        treeKey="id"
        label="链接"
        show-overflow-tooltip
      >
      </table-tree-column>
      <!-- <el-table-column
                prop="departmentCode"
                header-align="center"
                align="center"
                label="是否显示"
            >
            </el-table-column> -->
      <el-table-column
        prop="showStatus"
        label="是否显示"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="scope.row.showStatus === '0' ? 'danger' : 'success'"
            @click="changeShow(scope.row)"
          >
            {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
          </el-button>
        </template>
      </el-table-column>
      <!-- // -->
      <el-table-column prop="control" label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="scope.row.control === 0 ? 'danger' : 'success'"
            @click="changecontrol(scope.row)"
          >
            {{ scope.row.control === 0 ? "固定" : "移动" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        header-align="center"
        align="center"
        label="类型"
        width="80"
      >
      </el-table-column>
        <el-table-column
        prop="orderNumber"
        header-align="center"
        align="center"
        label="排序"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="添加时间"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
            >修改
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total,prev, pager, next"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import { treeDataTranslate } from "@/utils";
import TableTreeColumn from "@/components/table-tree-column";
import AddOrUpdate from "./enterpriseDepartment-add-or-update";
import { showcontent } from "@/utils/method.js";

export default {
  data() {
    return {
      dataForm: {
        enterpriseId: "",
        link: "",
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  components: {
    TableTreeColumn,
    AddOrUpdate,
  },
  activated() {
    this.getDataList();
  },
  methods: {
    showcontent,
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/bayWindow/findPageList"),
        method: "post",
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
        },
        // params: this.$http.adornParams({
        //     link: this.dataForm.link,
        //     enterpriseId: this.dataForm.enterpriseId,
        // }),
      }).then(({ data }) => {
        console.log(data);
        if (data.code == 0) {
          data.data.list.forEach((e) => {
            if (e.type == "0") {
              e.type = "诚信承诺书";
            } else {
              e.type = "飘窗";
            }
          });
          this.dataList = treeDataTranslate(data.data.list, "id", "parentId");
          this.totalPage = data.data.totalCount;
          this.dataListLoading = false;
        } else {
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      console.log(id);
      var ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(
        `确定对[id=${ids.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$http({
          url: this.$http.adornUrl("/bayWindow/deleteById?id=" + `${ids}`),
          method: "get",
          // data: {id:ids},
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
              },
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 点击显示/不显示按钮
    changeShow(item) {
      console.log(item);
      let { id } = item;
      // showStatus = showStatus === "1" ? "0" : "1";
      this.$ajaxGet("/bayWindow/display/open", {
        id: id,
        // showStatus,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.getDataList();
        }
      });
    },
    // 点击显示/不显示按钮
    changecontrol(item) {
      console.log(item);
      let { id } = item;
      // showStatus = showStatus === "1" ? "0" : "1";
      this.$ajaxGet("/bayWindow/setControl/open", {
        id: id,
        // showStatus,
      }).then(({ data }) => {
        if (data.code === 0) {
          this.getDataList();
        }
      });
    },
  },
};
</script>
